<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Job Listing
        div.small.text-muted
          | Displaying Analytics In Job Applications
      div.col-sm-7
        //- div.pull-right.ml-1.hidden-sm-down
            app-exportgraph(data='jobChart', :userAccessLevel='userAccessLevel')
        //- b-btn.pull-right.ml-1(type='button', variant='primary', @click='exportGraph')
          i.icon-cloud-download
          | &nbsp;Export
        //- div.pull-right.ml-1.hidden-sm-down
        //-   app-dateselectionwebsitesurvey(data='customer', :userAccessLevel='userAccessLevel')
        //- b-btn.pull-right.ml-1(type='button', variant='outline-primary', @click='monthlyGraph')
        //-   | Last 30 days
        //- b-btn.pull-right.ml-1(type='button', variant='outline-primary', @click='weeklyGraph')
        //-   | Last 7 days
        b-btn.pull-right.ml-1(id='refreshButton' type='button', variant='success', @click='refreshGraph', v-if='graphOutdatedStatus')
          | Data updated, please refresh
    //- br
    //- div.row
    //-   div.col-sm-12
    //-     h6.mb-0.text-center
    //-       | {{dateRangeStart | moment("Do MMM 'YY")}} - {{dateRangeEnd | moment("Do MMM 'YY")}}
    br
    job-chart(id='lineGraph' :daysOfGraph='daysOfGraph' :graphData='graphDataUpdate')
    br
    app-table(:data='jobTableItems', :label='jobTableFields', sortBy='timestamp', :sortDesc='true')
    br
    div.row
      div.col-sm-12
        ul(id="example-1")
          li(v-for="textToChange in textToChanges")
            | {{ textToChange }}
    //-     h4.card-title.mb-0
    //-       | Overall Website Survey Rating
    //-     div.small.text-muted
    //-       | Displaying Analytics In Overall Website Survey Rating
    //-   div.col-sm-7
    //-     div.pull-right.ml-1.hidden-sm-down
    //-         app-exportgraph(data='overallWebsiteChart', :userAccessLevel='userAccessLevel')
    //-     //-b-btn.pull-right.ml-1(type='button', variant='primary', @click='exportGraph2')
    //-         i.icon-cloud-download
    //-         | &nbsp;Export
    //- br
    //- div.row
    //-   div.col-sm-12
    //-     h6.mb-0.text-center
    //-       | {{dateRangeStart | moment("Do MMM 'YY")}} - {{dateRangeEnd | moment("Do MMM 'YY")}}
    //- br
    //- overall-website-survey(id='lineGraph' :daysOfGraph='daysOfGraph' :graphData='graphDataUpdate')
</template>

<script>
import JobChart from '../../methods/JobAnalyticsChart'
// import OverallWebsiteSurvey from '../../methods/OverallWebsiteSurveyChart'
import { db } from '@/firebase'
const moment = require('moment-timezone')
const cusRef = db.ref('custom')

export default {
  name: 'dashboard',
  components: {
    JobChart,
  },
  data() {
    return {
      jobTableItems: [
      ],
      jobTableFields: {
        timestamp: {
          label: 'Date',
        },
        email: {
          label: 'Email',
        },
        job: {
          label: 'Position Applied',
        },
        linked: {
          label: 'Linked In',
        },
        reason: {
          label: 'Reason',
          thStyle: {
            minWidth: '20em',
          },
        },
        qualification: {
          label: 'Qualification',
        },
        rating: {
          label: 'Rating (/100)',
        },
        manualRate: {
          label: 'Manual Rating',
        },
      },
      initialise: true,
      graphStatus: 'sevenDays',
      graphOutdatedStatus: false,
      daysOfGraph: {
        days: 8,
        timestamp: new Date(),
      },
      graphLabels: [],
      userData: [],
      interactionsData: [],
      userAccessLevel: this.$store.state.profile.accessLevel,
      usersCount: 0,
      interactionsCount: 0,
      todayUsersCount: 0,
      thisWeekUsersCount: 0,
      thisMonthUsersCount: 0,
      todayInteractionsCount: 0,
      thisWeekInteractionsCount: 0,
      thisMonthInteractionsCount: 0,
      textToChanges: [],
      topics: null,
      actions1: [{ name: 'View More' }],
      // STATS IS BROKEN
      dataPoints: null,
      height: 20,
      stats: () => {
        return {
        }
      },
    }
  },
  watch: {
    startEndDateUpdate: async function() {
      this.getGraph()
    },
  },
  computed: {
    startEndDateUpdate: function() {
      return this.$store.state.startEndDate
    },
    graphDataUpdate: function() {
      return this.$store.state.graphData
    },
    dateRangeStart: function() {
      return `${this.$store.state.startEndDate.startingDate}`
    },
    dateRangeEnd: function() {
      return `${this.$store.state.startEndDate.endingDate}`
    },
  },
  mounted: function() {
    var endDate = new Date()
    var startDate = new Date(endDate - 7 * 24 * 60 * 60 * 1000)
    var sDate = this.formatDate(new Date(startDate))
    var eDate = this.formatDate(new Date(endDate))
    var startEndDate = {
      startingDate: sDate,
      endingDate: eDate,
    }
    this.$store.dispatch('setStartEndDate', startEndDate)
    var graphStatus = 'sevenDays'
    this.$store.dispatch('setGraphStatus', graphStatus)

    cusRef.child('jobRequirement').on('value', (snapshot) => {
      this.graphOutdatedStatus = true
      if (this.initialise == true) {
        this.graphOutdatedStatus = false
        this.initialise = false
      }
    })
  },
  methods: {
    getGraph() {
      // if (this.$data.textToChanges.length != 0) {
      //   this.$data.textToChanges = []
      // }
      const that = this
      // let yAxisLabels = []
      // let star = [[], [], []]
      // let failure = []
      // let details = ''
      // let i = 0
      let jobArray = []
      let jobNumberArray = []
      this.$data.jobTableItems = []
      cusRef.child('jobRequirement').once('value', (snapshot) => {
        Object.entries(snapshot.val()).forEach(
          function([key, val]) {
            // yAxisLabels.push(val.name)
            let objectToPush = {
              timestamp: Number(val.timestamp),
              email: val.email,
              job: val.job,
              linked: val.linked,
              reason: val.reason,
              qualification: val.qualification,
              rating: val.rating,
              manualRate: {
                value: val.manualRate,
                key: key,
              },
            }
            that.$data.jobTableItems.push(objectToPush)
            if (jobArray.indexOf(val.job) != '-1') {
              jobNumberArray[jobArray.indexOf(val.job)] += 1
            } else {
              jobArray.push(val.job)
              jobNumberArray.push(1)
            }
          }
        )

        var graphData = {
          jobArray: jobArray,
          jobNumberArray: jobNumberArray,
          timestamp: new Date(),
        }
        that.$store.dispatch('setGraphData', graphData)
      })
    },
    exportGraph() {
      // used for date and file naming
      var dateStringToAdd = moment(this.$store.state.temporaryStartEndDate.startingDate).format(`Do MMM 'YY`) + ' - ' + moment(this.$store.state.temporaryStartEndDate.endingDate).format(`Do MMM 'YY`)
      var d = new Date()
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      var canvas = document.getElementById('bar-chart')
      var ctx = canvas.getContext('2d')
      // creates image
      var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      var data = imgData.data
      for (var i = 0; i < data.length; i += 1) {
        if (data[i] < 1) {
          data[i] = 255
        }
      }
      canvas.height = canvas.height + 40
      ctx.putImageData(imgData, 0, 40)
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, canvas.width, 40)
      ctx.fillStyle = 'black'
      ctx.font = '25px sans-serif'
      ctx.fillText('Website Survey Received/Average Rating', 10, 20)
      ctx.font = '20px sans-serif'
      ctx.fillText(dateStringToAdd, 10, 40)
      var url = canvas.toDataURL('image/png', 1)
      var link = document.createElement('a')
      link.href = url
      link.download = 'imSME_ChatBot_TotalInteractionsAndUsersChart_' + year + month + day + '.png'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      // Cleanup the DOM
      document.body.removeChild(link)
      this.$store.dispatch('setExportGraphStatus', false)
      this.refreshGraph()
    },
    exportGraph2() {
      // used for date and file naming
      var dateStringToAdd = moment(this.$store.state.temporaryStartEndDate.startingDate).format(`Do MMM 'YY`) + ' - ' + moment(this.$store.state.temporaryStartEndDate.endingDate).format(`Do MMM 'YY`)
      var d = new Date()
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      var canvas = document.getElementById('horizontalbar-chart')
      var ctx = canvas.getContext('2d')
      // creates image
      var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      var data = imgData.data
      for (var i = 0; i < data.length; i += 1) {
        if (data[i] < 1) {
          data[i] = 255
        }
      }
      canvas.height = canvas.height + 40
      ctx.putImageData(imgData, 0, 40)
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, canvas.width, 40)
      ctx.fillStyle = 'black'
      ctx.font = '25px sans-serif'
      ctx.fillText('Overall Website Survey Rating', 10, 20)
      ctx.font = '20px sans-serif'
      ctx.fillText(dateStringToAdd, 10, 40)
      var url = canvas.toDataURL('image/png', 1)
      var link = document.createElement('a')
      link.href = url
      link.download = 'imSME_ChatBot_TotalInteractionsAndUsersChart_' + year + month + day + '.png'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      // Cleanup the DOM
      document.body.removeChild(link)
      this.$store.dispatch('setExportGraphStatus', false)
      this.refreshGraph()
    },
    refreshGraph () {
      const startEndDate = {
        timestamp: new Date(),
      }
      this.graphOutdatedStatus = false
      this.$store.dispatch('setStartEndDate', startEndDate)
    },
    weeklyGraph () {
      this.daysOfGraph = {
        days: 8,
        timestamp: new Date(),
      }
      var endDate = new Date()
      var startDate = new Date(endDate - 7 * 24 * 60 * 60 * 1000)
      var sDate = this.formatDate(new Date(startDate))
      var eDate = this.formatDate(new Date(endDate))
      var startEndDate = {
        startingDate: sDate,
        endingDate: eDate,
      }
      var graphStatus = 'sevenDays'
      this.$store.dispatch('setGraphStatus', graphStatus)
      this.$store.dispatch('setStartEndDate', startEndDate)
    },
    monthlyGraph () {
      this.daysOfGraph = {
        days: 31,
        timestamp: new Date(),
      }
      var endDate = new Date()
      var startDate = new Date(endDate - 30 * 24 * 60 * 60 * 1000)
      var sDate = this.formatDate(new Date(startDate))
      var eDate = this.formatDate(new Date(endDate))
      var startEndDate = {
        startingDate: sDate,
        endingDate: eDate,
      }
      var graphStatus = 'thirtyDays'
      this.$store.dispatch('setGraphStatus', graphStatus)
      this.$store.dispatch('setStartEndDate', startEndDate)
    },
    yearlyGraph () {
      this.daysOfGraph = 365
    },
    increaseHeight () {
      this.height += 10
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    // User Chat Link
    chatLink (value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-')
    },
    formatDate: function(date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    formatDateSpace: function(date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/JobAnalytics.vue?c20bfffe